module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"settings":"Settings","properties":"Properties","rooms":"Rooms","name":"Name","quantity":"No. of Units","beds":"No. of Beds","create":"Create new room type"},"sl":{"settings":"Nastavitve","properties":"Nastanitve","rooms":"Sobe","name":"Naziv","quantity":"Št. enot","beds":"Št. ležišč","create":"Ustvari nov tip sobe"}}')
  delete Component.options._Ctor
}
